import React from "react"
import PropTypes from "prop-types"
import styles from "./Section.module.css"

const Section = ({ heading, children, isQuoteHeader }) => (
  <section>
    <div className={styles.content}>
      <div className={styles.divider}/>
      <h1 className={`${isQuoteHeader ? styles.quoteHeader : ""}`}>{heading}</h1>
      {children}
    </div>
  </section>
)

Section.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.any,
  isQuoteHeader: PropTypes.bool
}

export default Section